import { useMemo } from "react"
import { Attribute, DeviceDocument, GroupDocument } from "../../../contexts/devices-context"

export default <Keys extends string, Attr = Attribute>(source: DeviceDocument | GroupDocument, moduleName: string) =>
    useMemo(
        () =>
            source.modules
                .find(module => module.name === moduleName)
                ?.attributes.reduce((acc, curr) => ({ ...acc, [curr.name]: curr }), {} as Record<Keys, Attr>),
        [source],
    )
